import React, { useState } from "react";
import { resetPassword } from "../api";
import { Link } from "react-router-dom";
import Animation from "../components/Animation";

export default function PasswordReset() {
    const [username, setUsername] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handlePasswordReset = async () => {
        setLoading(true);
        setMessage("");
        await new Promise((resolve) => setTimeout(resolve, 2000));
        try {
            const data = await resetPassword(username);

            if (data.message) {
                setMessage(`${data.message}`);
            } else {
                setMessage(data.error || "Namen nicht gefunden. Vergewissern Sie sich Vor- & Nachnamen einzutragen mit einem Leerzeichen.");
            }
        } catch (error) {
            setMessage("Ein unbekannter Fehler ist aufgetreten. Versuche es bitte erneut.");
            console.error("Reset error:", error);
        }

        setLoading(false);
    };

    return (
        <div className="password-reset-container">
            <h2>Reset Password</h2>
            <p>Trage deinen Vor- & Nachnamen ein. In Folge erhälst du einen Password-Reset-Link.</p>
            <div style={{ display: "flex", gap: "1rem", alignItems: "stretch", marginBottom: "1rem" }}>
  <input
    type="text"
    placeholder="Username"
    value={username}
    onChange={(e) => setUsername(e.target.value)}
    style={{
      flex: 1,
      padding: "8px 12px",
      fontSize: "16px",
      border: "2px solid #ff7043",
      borderRadius: "8px",
      background: "rgba(255, 255, 255, 0.8)",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      outline: "none",
      boxSizing: "border-box",
      height:"46px",
    }}
  />
  <button
    onClick={handlePasswordReset}
    disabled={loading}
    style={{
      padding: "0 16px",
      fontSize: "16px",
      border: "none",
      borderRadius: "8px",
      backgroundColor: "#ff7043",
      color: "#fff",
      fontWeight: "bold",
      cursor: "pointer",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      transition: "all 0.3s ease",
      height:"45px",
    }}
  >
    {loading ? "Sending..." : "Send Reset Link"}
  </button>
  <Animation loading={loading}/>
</div>

            {message && <p className="message">{message}</p>}

            <div style={{ marginTop: "1rem" }}>
                <Link to="/login">Login</Link>
            </div>
        </div>
    );
}
